import OnlineAppComponent from "../lib/online_app_component";
import {subMarkerContentForExperience} from "../views/sub_marker_content";
import Component from "../../lib/component";
import {OnlineAppRootConfig} from "./online_app_root/online_app_root";

export const OnlineAppSubmarkerConfig = {
    baseHtmlClass: 'submarker'
}

export class OnlineAppSubmarker extends OnlineAppComponent {

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppSubmarkerConfig);
        this.currentExperienceMarker = null;
        this.currentSize = null;
        this.element = Component.createElement(OnlineAppSubmarkerConfig.baseHtmlClass);
        this.infoBoxOptions = this.getDefaultInfoBoxOptions();
        this.infoBox = new InfoBox(this.infoBoxOptions);

        this.resizeTicking = false;
        this.onlineApp.env.addEventListener('resize', this.handleResize.bind(this));

        this.element.addEventListener('click', (event) => {
            event.preventDefault();
            this.dispatchAction('subMarkerClicked', this);
        });

        this.render();
    }

    handleResize(event) {
        if (!this.resizeTicking) {
            requestAnimationFrame((timestamp) => {
                this.resizeTicking = false;
                this.render();
            });
        };
        this.resizeTicking = true;
    }

    // https://github.com/googlemaps/v3-utility-library/tree/master/archive/infobox
    getDefaultInfoBoxOptions() {
        return {
            disableAutoPan: false,
            alignBottom: true,
            pixelOffset: new google.maps.Size(0, 0),
            infoBoxClearance: new google.maps.Size(16, 60),
            closeBoxURL: ''
        };
    }

    setElementContent(experienceMarker) {
        this.element.innerHTML = subMarkerContentForExperience(experienceMarker.rawExperienceData);
    }

    openInfoBox(experienceMarker){
        this.addHtmlClassState('info_box_open');

        const onlineAppMap = this.onlineApp?.map;
        if (!onlineAppMap) return;

        this.infoBox.open(onlineAppMap.googleMap, experienceMarker.googleMarker);

        if (this.readState('navOpen')) {
            // TODO - If (after the infoBox is open and may have panned) the marker is behind the nav then we offset the map to pan the marker out from behind the nav.
        }
    }

    closeInfoBox(){
        this.removeHtmlClassState('info_box_open');
        this.infoBox.close();
    }

    // The InfoBox pixelOffset option is the offset from the map position.
    pixelOffset() {
        let h = 0;
        let v = -7; // offset for the submarker pointer PNG
        const horizontalBorderAdjustment = -2;
        switch (this.currentSize) {
            case 'small':
                h = -70 + horizontalBorderAdjustment;
                break;
            case 'medium':
                h = -140 + horizontalBorderAdjustment;
                break;
        }
        return new google.maps.Size(h, v);
    }

    renderSize() {
        this.removeHtmlClassState('small');
        this.removeHtmlClassState('medium');
        if (this.currentSize) { this.addHtmlClassState(this.currentSize) };
    }

    renderContent(experienceMarker=null) {
        if (experienceMarker) { this.setElementContent(experienceMarker) };
        this.infoBox.setContent(this.element);
        this.infoBoxOptions.pixelOffset = this.pixelOffset();
        this.infoBox.setOptions(this.infoBoxOptions);
    }

    isDifferentExperienceMarker(experienceMarker){
        return this.currentExperienceMarker !== experienceMarker
    }

    render() {
        const modeCode = this.readState('modal');
        this.currentSize = (modeCode === OnlineAppRootConfig.modalModeCode) ? 'small' : 'medium';
        this.renderSize();

        const experienceMarker = this.readState('experienceMarker');

        if (experienceMarker) {

            this.renderContent(experienceMarker);

            if (this.isDifferentExperienceMarker(experienceMarker)) {
                this.currentExperienceMarker = experienceMarker;
                this.openInfoBox(experienceMarker);
            }

        } else {
            this.closeInfoBox();
        }

        this.currentExperienceMarker = experienceMarker;
    }

}